import { ConfirmDialogActions } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmDialogResolver } from 'legacy/lut/components/shared/Confirm/ConfirmContextProvider'
import { ConfirmDialogState, initialState } from 'legacy/lut/components/shared/Confirm/reducer'
import { createContext, Dispatch, MutableRefObject } from 'react'

export const ConfirmContext = createContext<
  [ConfirmDialogState, Dispatch<ConfirmDialogActions>, MutableRefObject<ConfirmDialogResolver>]
>([initialState, () => undefined, { current: {} }])
